import styled from "styled-components";
import { BasicSectionContainer } from "../../../style";
import { styleSizes } from "constants/styleSizes";
import { colors } from "constants/colors";

export const PersonalDetails = styled(BasicSectionContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-items: stretch;
  gap: 32px;
  overflow: visible;

  .cardContent {
    .topText {
      font-size: 16px;
      font-weight: 400;
      margin-bottom: 30px;
      line-height: 24px;
    }

    .fullName,
    .addressFields {
      max-width: 520px;
    }

    .addressRow {
      display: flex;
      gap: 0 8px;

      .inpuntCont {
        flex: 1;
        min-width: 0;
      }

      @media (max-width: ${styleSizes.mobileBreakpoint}) {
        flex-direction: column;
        gap: 0;
      }
    }
    .dateOfBirth {
      max-width: 255px;
      position: relative;
    }
    .inpuntCont {
      margin-bottom: 28px;
      @media (max-width: ${styleSizes.mobileBreakpoint}) {
        margin-bottom: 28px;
      }
      label {
        font-size: 14px;
        font-weight: 400;
        color: ${colors.secLabel};
      }
    }
    .saveButton {
      @media (max-width: ${styleSizes.mobileBreakpoint}) {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
      }
    }

    .border-arrow {
      position: relative; /* Required for positioning the arrow */
      padding: 20px; /* Space inside the div */
      background: ${colors.white}; /* Background color */
      border: 2px solid ${colors.hoverBlue}; /* Border color */
      margin: 20px; /* Space around the div */
    }
  }
`;
